
'use strict';

icing.watch('[data-bs-toggle*="popover"]', e => new Popover(e));
